import React, { PureComponent } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { Tab, Tabs } from '@dbk/ui-tabs';
import UploadDocumentTabView from '../upload-document-tab/upload-document-tab-view';
import UploadHistoryTabView from '../upload-history-tab/upload-history-tab-view';

class DocUploadTabContainer extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0
    };
  }

  handleSelectedIndex = (index) => {
    this.setState({ selectedTab: index })
  }

  render() {
    const { i18n: { messages } } = this.props;
    return (
      <div className="columns small-12 medium-12 large-12 document-upload margin-bottom-25">
        <div className="text-center margin-top-26 large-10 large-centered">
          <div className="document-upload-title">
            {messages['app.documentUpload.title']}
          </div>
        </div>
        <div className="columns small-12 medium-12 large-12">
          <div className="columns small-8 medium-8 large-6 medium-centered">
            <Tabs
              stretch
              secondary
              handleSelectedIndex={(index) => this.handleSelectedIndex(index)}
              selectedIndex={this.state.selectedTab} >
              <Tab testID="tab_doc_bp_search_view_uploadDocument_test" accessibilityLabel="tab_doc_bp_search_view_uploadDocument_test" style={{ fontSize: 16 }} renderLabel={() => messages['app.documentUpload.tab.uploadDocument']} />
              <Tab testID="tab_doc_bp_search_view_uploadHistory_test" accessibilityLabel="tab_doc_bp_search_view_uploadHistory_test" style={{ fontSize: 16 }} renderLabel={() => messages['app.documentUpload.tab.uploadHistory']} />
            </Tabs>
          </div>
          {
            this.state.selectedTab === 0 ?
              <UploadDocumentTabView /> :
              <UploadHistoryTabView />
          }
        </div>
      </div>
    );
  }
}

export default createContainer({
  $queries: {
    i18n: {
      messages: true,
    },
  },
})(DocUploadTabContainer);
